module.exports = __webpack_public_path__ + "kitchensmartlogo.f455f7eb.svg";